//Set staging flag to true to be added in request URL if you need to retrieve non-published Contentful forms for development.
export const STAGING_FORMS = false;
export const FORM_NAME = 'formSchema';
export const FORM_PAGE_NAME = 'FormPage-';
export const FORM_SUBMIT = 'formSubmit';
